// Clinical Studies Mobile - Carousel JavaScript
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.studies-carousel');
    const slides = Array.from(carousel.querySelectorAll('.study-block'));
    const prevButton = document.querySelector('.carousel-prev-button');
    const nextButton = document.querySelector('.carousel-next-button');
    let currentIndex = 0;
    
    const offsetPx = 240;
    
    function updatePositions() {
      slides.forEach((slide, i) => {
        const diff = i - currentIndex;
        const scale = (diff === 0) ? 1 : 0.65;
        const xOffset = diff * offsetPx;
        slide.style.transform = `translate(-50%, -50%) translateX(${xOffset}px) scale(${scale})`;
        slide.style.zIndex = (diff === 0) ? 10 : 5;
        slide.style.opacity = (Math.abs(diff) > 1) ? 0 : 1;
      });
    }
    
    updatePositions();
    
    slides.forEach((slide, i) => {
      slide.addEventListener('click', () => {
        currentIndex = i;
        updatePositions();
        updateNavButtons();
      });
    });
    
    let startX = 0;
    let isTouching = false;
    
    carousel.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isTouching = true;
    });
    
    carousel.addEventListener('touchend', (e) => {
      if (!isTouching) return;
      const endX = e.changedTouches[0].clientX;
      const diffX = endX - startX;
      if (diffX < -50 && currentIndex < slides.length - 1) {
        currentIndex++;
      } else if (diffX > 50 && currentIndex > 0) {
        currentIndex--;
      }
      updatePositions();
      updateNavButtons();
      isTouching = false;
    });
    
    let isDown = false;
    let startDragX = 0;
    
    carousel.addEventListener('mousedown', (e) => {
      e.preventDefault();
      startDragX = e.clientX;
      isDown = true;
    });
    
    document.addEventListener('mouseup', (e) => {
      if (!isDown) return;
      const diffX = e.clientX - startDragX;
      if (diffX < -50 && currentIndex < slides.length - 1) {
        currentIndex++;
      } else if (diffX > 50 && currentIndex > 0) {
        currentIndex--;
      }
      updatePositions();
      updateNavButtons();
      isDown = false;
    });
    
    prevButton.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updatePositions();
        updateNavButtons();
      }
    });
    
    nextButton.addEventListener('click', () => {
      if (currentIndex < slides.length - 1) {
        currentIndex++;
        updatePositions();
        updateNavButtons();
      }
    });
    
    function updateNavButtons() {
      if (currentIndex === 0) {
        prevButton.style.opacity = 0.5;
        prevButton.style.cursor = 'not-allowed';
      } else {
        prevButton.style.opacity = 1;
        prevButton.style.cursor = 'pointer';
      }
    
      if (currentIndex === slides.length - 1) {
        nextButton.style.opacity = 0.5;
        nextButton.style.cursor = 'not-allowed';
      } else {
        nextButton.style.opacity = 1;
        nextButton.style.cursor = 'pointer';
      }
    }
    
    updateNavButtons();
  });
})();
